<template>
    <div class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col cols="12" md="10">
                    <b-link :to="{ name: 'contacts-lists' }">
                        <font-awesome-icon icon="arrow-left" />
                        {{ $t("Back") }}
                    </b-link>

                    <h1 class="mt-1">{{ $t("contacts.lists.contacts-lists") }} / {{ $t("Add") }}</h1>
                    <hr />

                    <contact-lists-form @canceled="backToOverview" @finished="backToOverview" />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { BContainer, BCol, BRow, BLink } from "bootstrap-vue";
import ContactListsForm from "@/views/components/contact-lists/contactListsForm.vue";
import useContactsLists from "@/composables/useContactsLists";
import { useRouter } from "@/@core/utils/utils";

export default {
    components: {
        BContainer,
        BCol,
        BRow,
        BLink,
        ContactListsForm,
    },
    setup() {
        const { router } = useRouter();
        const { contactsList } = useContactsLists();
        // @STEPBACK
        contactsList.value = {
            name: null,
            description: null,
            reference: null,
            contacts: [],
            importedContactData: false,
            updateExistingContacts: true,
        };

        const backToOverview = () => {
            router.push({ name: "contacts-lists" });
        };

        return {
            contactsList,
            backToOverview,
        };
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
